import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { BookingItemEffects } from './booking-item.effects'
import * as fromBookingItem from './booking-item.reducer'
import { BookingItemSerializer } from './booking-item.serializer'
import { BookingItemService } from './booking-item.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromBookingItem.FEATURE_NAME,
      fromBookingItem.bookingItemReducer
    ),
    EffectsModule.forFeature([BookingItemEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    BookingItemService,
    {
      provide: BookingItemSerializer,
      useClass: BookingItemSerializer
    }
  ]
})
export class BookingItemModule {}
